import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { ConfigurationBackend } from "src/app/backend/api/configuration.backend";
import { lastValueFrom } from "rxjs";

@Injectable()
export class ProvideAppointmentConfigurationGuard {
  private bootstrapService = inject(BootstrapService);
  private configurationBackend = inject(ConfigurationBackend);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const configuration = await lastValueFrom(
      this.configurationBackend.loadCalendar()
    );

    this.bootstrapService.setCurrentAppointmentConfiguration(configuration);

    return true;
  }
}
